/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Analyze_With_AiInputs */

const en_jobs_analyze_with_ai = /** @type {(inputs: Jobs_Analyze_With_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze with AI`)
};

const de_jobs_analyze_with_ai = /** @type {(inputs: Jobs_Analyze_With_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit KI analysieren`)
};

const fr_jobs_analyze_with_ai = /** @type {(inputs: Jobs_Analyze_With_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyser avec l'IA`)
};

const es_jobs_analyze_with_ai = /** @type {(inputs: Jobs_Analyze_With_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analizar con IA`)
};

const it_jobs_analyze_with_ai = /** @type {(inputs: Jobs_Analyze_With_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analizza con AI`)
};

const nl_jobs_analyze_with_ai = /** @type {(inputs: Jobs_Analyze_With_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyseren met AI`)
};

const pl_jobs_analyze_with_ai = /** @type {(inputs: Jobs_Analyze_With_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analizuj z AI`)
};

const fi_jobs_analyze_with_ai = /** @type {(inputs: Jobs_Analyze_With_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysoi tekoälyllä`)
};

const da_jobs_analyze_with_ai = /** @type {(inputs: Jobs_Analyze_With_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyser med AI`)
};

const sv_jobs_analyze_with_ai = /** @type {(inputs: Jobs_Analyze_With_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysera med AI`)
};

/**
* | output |
* | --- |
* | "Analyze with AI" |
*
* @param {Jobs_Analyze_With_AiInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_analyze_with_ai = /** @type {((inputs?: Jobs_Analyze_With_AiInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Analyze_With_AiInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_analyze_with_ai(inputs)
	if (locale === "fr") return fr_jobs_analyze_with_ai(inputs)
	if (locale === "es") return es_jobs_analyze_with_ai(inputs)
	if (locale === "it") return it_jobs_analyze_with_ai(inputs)
	if (locale === "nl") return nl_jobs_analyze_with_ai(inputs)
	if (locale === "pl") return pl_jobs_analyze_with_ai(inputs)
	if (locale === "fi") return fi_jobs_analyze_with_ai(inputs)
	if (locale === "da") return da_jobs_analyze_with_ai(inputs)
	if (locale === "sv") return sv_jobs_analyze_with_ai(inputs)
	return en_jobs_analyze_with_ai(inputs)
});